class FeaturedArticleSlider extends HTMLElement {
  constructor() {
    super();
    this.emblaInstance = null;
  }

  connectedCallback() {
    this.initEmbla();
    const prevButton = this.querySelector('.prev');
    const nextButton = this.querySelector('.next');

    if (prevButton) prevButton.addEventListener('click', () => this.scrollPrev());
    if (nextButton) nextButton.addEventListener('click', () => this.scrollNext());
  }

  async initEmbla() {
    const emblaNode = this.querySelector('.embla');
    if (emblaNode) {
      this.emblaInstance = EmblaCarousel(emblaNode, {
        loop: true,
        align: 'start',
      });
    }
  }

  scrollPrev() {
    if (this.emblaInstance) {
      this.emblaInstance.scrollPrev();
    }
  }

  scrollNext() {
    if (this.emblaInstance) {
      this.emblaInstance.scrollNext();
    }
  }

  disconnectedCallback() {
    const prevButton = this.querySelector('.prev');
    const nextButton = this.querySelector('.next');

    if (prevButton) prevButton.removeEventListener('click', () => this.scrollPrev());
    if (nextButton) nextButton.removeEventListener('click', () => this.scrollNext());

    if (this.emblaInstance) {
      this.emblaInstance.destroy();
    }
  }
}

customElements.define('featured-article-slider', FeaturedArticleSlider);
